<div class="flex-wrap" style="align-items: end;">
  <label class="pageName__title">{{dateControl.value | date : 'd MMM yyyy'}}</label>
  <input style="display: none;" matInput [matDatepicker]="picker" (dateChange)="dateChange.emit($event)"
    [formControl]="dateControl">
  <!-- <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle> -->
  <mat-datepicker [dateClass]="dateClass" #picker></mat-datepicker>
  <button mat-icon-button (click)="picker.open()">
    <mat-icon class="calendar-icon-button" [matBadge]="warningVal" matBadgeColor="warn" aria-hidden="false"><span class="icon">calendar_today</span></mat-icon>
  </button>
</div>
